import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class BigShipperWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "shipping fast", title: "Big Shipper Home", href: "/shipper" },
            { icon: "search", title: "Find Next Order", href: "/shipper/next" },
            { icon: "ship", title: "Shipments List", href: "/shipper/list" },
            { icon: "boxes", title: "Batch Shipper", href: "/shipper/batch" },
            { icon: "clipboard list", title: "Packing Queue", href: "/shipper/packing" },
            { icon: "clipboard list", title: "Fulfillment Queue", href: "/shipper/queue" },
            { icon: "clock", title: "Waiting for Pickup", href: "/shipper/pickup" },
            { icon: "bar chart", title: "Shipments Stats", href: "/shipper/stats" },
            { icon: "content", title: "Audit Logs", href: "/shipper/logs" },
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
